module.exports = __webpack_public_path__ + "static/media/about-18.77f9417c.png";